// Form field constants
export const FORM_FIELD_NAMES = {
    ERROR_NOTIFICATION_DATE: 'errorNotificationDate',
    CHASSIS_NO: 'chassisNo',
    VEHICLE_WARRANTY_INF: 'vehicleWarrantyInf',
    VEHICLE_MODEL_EMISSIONS: 'vehicleModelEmissions',
    VEHICLE_GSR: 'vehicleGsr',
    KM_INFORMATION: 'kmInformation',
    VEHICLE_CUSTOMER_INF: 'vehicleCustomerInf',
    ERROR_DESCRIPTION: 'errorDescription',
    CHECKS_PERFORMED: 'checksPerformed',
    ERROR_EFFECT: 'errorEffect',
    SOFTWARE_VERSION: 'softwareVersion',
    MORE_CHASSIS: 'moreChassis',
    ADDITIONAL_CHASSIS: 'additionalChassis',
    PROBLEM_SOLVED: 'problemSolved',
    SOLUTION_METHOD: 'solutionMethod',
    SOLUTION_DATE: 'solutionDate',
    ON_SITE_SUPPORT: 'onSiteSupport',
    ON_SITE_SUPPORT_REASON: 'onSiteSupportReason',
    TECHNICAL_SERVICE_DECLARATION: 'technicalServiceDeclaration',
    TECHNICAL_POLICY: 'technicalPolicy',
    VISIT_DATE: 'visitDate',
    VISIT_ERROR_DESC: 'visitErrorDesc',
    ROOT_CAUSE: 'rootCause',
    SOLUTION: 'solution',
    MAN_HOUR: 'manHour',
    OUTSOURCING_EXPENSE: 'outsourcingExpense',
    TOTAL_EXPENSES: 'totalExpenses',
    PTS_CRITERIA: 'ptsCriteria',
    PTS_NUMBER: 'ptsNumber',
    STATUS_NOTIFICATION: 'statusNotification',
    ACTION_MANAGER: 'actionManager'
};

// Lookup group codes
export const LOOKUP_GROUP_CODES = {
    FAULT_MAIN_CATEGORY: 'XXBOS_MAIN_CATEGORY',
    FAULT_SECOND_CATEGORY: 'XXBOS_SECONDARY_CATEGORY',
    FAULT_SUB_CATEGORY: 'XXBOS_SUB_CATEGORY',
    FAULT_SUB_PART_CATEGORY: 'XXBOS_SUB_PART_CATEGORY',
    FAULT_FAILURE_MODE: 'FAULT_FAILURE_MODE'
};

// Warranty options
export const WARRANTY_VALUES = {
    IN_WARRANTY: 1,
    OUT_OF_WARRANTY: 2
};

// Error effect values
export const ERROR_EFFECT_VALUES = {
    SAFETY: 1,
    VOR: 2,
    FUNCTION_LOSS: 3,
    REGULATION: 4,
    OTHER: 5
};

// Style constants
export const STYLES = {
    SECTION_HEADER: {
        backgroundColor: 'rgb(39, 58, 129)'
    },
    CHAT_CONTAINER: {
        maxHeight: '450px',
        backgroundColor: '#f8f9fa',
        backgroundImage: 'linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%)'
    },
    POLICY_DIALOG: {
        width: '70vw',
        maxWidth: '800px'
    },
    POLICY_CONTENT: {
        height: '60vh',
        backgroundColor: '#f8f9fa'
    },
    MAIN_DIALOG: {
        width: '90vw',
        maxWidth: '1400px'
    }
};

// User colors for chat
export const USER_COLORS = ['#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#F44336', '#00BCD4', '#FF5722', '#3F51B5', '#009688', '#E91E63', '#8BC34A', '#FFC107', '#673AB7', '#03A9F4', '#CDDC39', '#FF6F00', '#00897B', '#D32F2F', '#7B1FA2', '#1976D2'];

// Default values
export const DEFAULT_VALUES = {
    STATUS: 0,
    IS_ACTIVE: 1,
    LAST_UPDATE_SESSION: 'web',
    CHASSIS_ROW_COUNT: 2000
};
export const LONG_TEXT_MAX_LENGTH = 2500;

// Sohbet mesajı düz metin sınırı. LONG_TEXT_MAX_LENGTH ile aynı değerde olsa da ayrı
// tutulur; sohbet limiti değişirse form alanlarının etkilenmemesi gerekir.
export const CHAT_MESSAGE_MAX_LENGTH = 2500;

export const ACCEPTED_FILE_TYPES = {
    'image/*': ['.png', '.jpg', '.jpeg', '.gif'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'text/plain': ['.txt'],
    'application/octet-stream': ['.trc', '.rar'],
    'application/zip': ['.zip'],
    'application/x-zip-compressed': ['.zip'],
    'application/vnd.rar': ['.rar'],
    'application/x-rar-compressed': ['.rar']
};

export const MAX_FILE_SIZE = 104857600;
